import { render, staticRenderFns } from "./appointments.vue?vue&type=template&id=639f9cfc&scoped=true&"
import script from "./appointments.vue?vue&type=script&lang=js&"
export * from "./appointments.vue?vue&type=script&lang=js&"
import style0 from "./appointments.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./appointments.vue?vue&type=style&index=1&id=639f9cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f9cfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
